export const actionTypes = {
    setErrorMessage: "setErrorMessage",
};

const initialErrorState = {
    errorMessage: "",
};

export const errorReducer = (state = initialErrorState, action) => {
    switch (action.type) {
        case actionTypes.setErrorMessage: {
            const {errorMessage} = action.payload;
            errorMessage && console.error({errorMessage});
            return {errorMessage};
        }

        default:
            return state;
    }
};

export const errorActions = {
    setErrorMessage: errorMessage => dispatch =>
        dispatch({
            type: actionTypes.setErrorMessage,
            payload: {errorMessage},
        }),
};
